import React, { useState, useEffect } from "react";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";

import Input from "../../components/Control/Input";
import { Wrapper } from "../../components/Control/Flexbox";
import PdfImage from "../../images/pdf.png";
import Loader from "../../components/Control/Loader";

const MiscDocumentsDrawingsInputs = ({ currentId, setOpenModal }) => {
  const [uploadFiles, setUploadFiles] = useState({
    file: null,
  });
  const [preview, setPreview] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [miscDrawingsData, setMiscDrawingsData] = useState({});
  const [render, setRender] = useState(false);

  useEffect(() => {
    if (!currentId) return;
    axios(`/api/getOneMiscDocumentsDrawings/data/${currentId}`)
      .then((res) => {
        setMiscDrawingsData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsloading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [isLoading]);

  useEffect(() => {
    if (!uploadFiles.file) return;
    setPreview(URL.createObjectURL(uploadFiles.file));
    return () => {
      URL.revokeObjectURL(uploadFiles.file);
    };
  }, [uploadFiles]);

  const handleImagePdf = (e) => {
    setUploadFiles({
      file: e.target.files[0],
    });
    e.target.value = "";
    setIsloading(true);
  };

  const removeFiles = () => {
    setUploadFiles({
      file: null,
    });
    setPreview(null);
    miscDrawingsData.miscDocumentsDrawingFiles = null;
  };

  const handleDrawingData = (e) => {
    miscDrawingsData[e.target.name] = e.target.value;
    setRender((prev) => !prev);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("document_name", miscDrawingsData.document_name);
    formData.append("document_type", miscDrawingsData.document_type);
    formData.append(
      "document_description",
      miscDrawingsData.document_description
    );

    if (miscDrawingsData._id) {
      formData.append(
        "miscDocumentsDrawingFiles",
        uploadFiles.file || miscDrawingsData.miscDocumentsDrawingFiles
      );
      axios
        .put(`/api/updateMiscDocumentsDrawings/data/${currentId}`, formData)
        .then((res) => {
          setOpenModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      formData.append("miscDocumentsDrawingFiles", uploadFiles.file);
      axios
        .post(`/api/miscDocumentsDrawings/create`, formData)
        .then((res) => {
          alert("success");
          setOpenModal(false);
        })
        .catch((err) => console.log(err));
    }
  };
  const ShowPdf = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "2rem 0 0.5rem 0",
          filter: "drop-shadow(10px 10px 5px #868e96)",
        }}
      >
        <img src={PdfImage} height="250px" width="250px" />
      </div>
    );
  };

  return (
    <div>
      <Wrapper style={{ marginTop: "1rem" }}>
        <div>
          <Input
            label="Document Name"
            name="document_name"
            type="text"
            defaultValue={miscDrawingsData.document_name}
            onChange={handleDrawingData}
            value={miscDrawingsData.document_name}
          />
        </div>
        <div>
          <Input
            label="Document Type"
            name="document_type"
            type="text"
            defaultValue={miscDrawingsData.document_type}
            onChange={handleDrawingData}
            value={miscDrawingsData.document_type}
          />
        </div>
        <div>
          <Input
            label="Document Description"
            name="document_description"
            type="text"
            defaultValue={miscDrawingsData.document_description}
            onChange={handleDrawingData}
            value={miscDrawingsData.document_description}
          />
        </div>
      </Wrapper>

      <Wrapper style={{ justifyContent: "center" }}>
        <div>
          {isLoading ? (
            <Loader height={"20vh"} />
          ) : (
            <>
              {uploadFiles.file &&
                uploadFiles.file?.type === "application/pdf" && <ShowPdf />}
              {preview ? (
                uploadFiles.file.type !== "application/pdf" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "2rem 0 0rem 0",
                    }}
                  >
                    <img
                      src={preview ? preview : ""}
                      alt=""
                      height="auto"
                      width="50%"
                    />
                  </div>
                )
              ) : (
                <>
                  {miscDrawingsData?.miscDocumentsDrawingFiles &&
                  miscDrawingsData.miscDocumentsDrawingFiles.slice(-3) ===
                    "pdf" ? (
                    <ShowPdf />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "2rem 0 0rem 0",
                      }}
                    >
                      {miscDrawingsData?.miscDocumentsDrawingFiles &&
                      miscDrawingsData?.miscDocumentsDrawingFiles !== "null" ? (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src={miscDrawingsData?.miscDocumentsDrawingFiles}
                            alt=""
                            height="auto"
                            width="50%"
                          />
                        </div>
                      ) : (
                        <CloudUploadOutlinedIcon
                          style={{ fontSize: "105px", color: "#868e96" }}
                        />
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "1.2rem",
            }}
          >
            <input
              id="contained-button-file"
              type="file"
              name="pcs_imageOrPdf"
              accept="image/png,image/jpeg,image/jpg/,application/pdf"
              onChange={handleImagePdf}
              hidden
            />
            <label
              htmlFor="contained-button-file"
              style={{
                marginBottom: "0",
              }}
            >
              <Button variant="outlined" component="span" color="secondary">
                <CloudUploadIcon style={{ marginRight: "1rem" }} />
                Upload Picture / Pdf
              </Button>
            </label>
            {(uploadFiles.file ||
              miscDrawingsData.miscDocumentsDrawingFiles) && (
              <Button
                variant="outlined"
                type="button"
                color="primary"
                style={{
                  marginLeft: "0.6rem",
                }}
                onClick={removeFiles}
                startIcon={<DeleteIcon />}
              >
                REMOVE
              </Button>
            )}
          </div>
        </div>
      </Wrapper>

      <div
        className="btn_save"
        style={{
          position: "absolute",
          right: "150px",
          top: "9px",
        }}
      >
        <Button
          type="submit"
          variant="outlined"
          color="white"
          size="large"
          style={{ color: "#e9e9e9" }}
          startIcon={<SaveIcon />}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default MiscDocumentsDrawingsInputs;
